import React, { useState } from 'react';
import Button from '@techsoftware/happay-widgets/Button';
import DialogBox from '@techsoftware/happay-widgets/DialogBox';
import Grid from '@techsoftware/happay-widgets/Grid';
import { currencyFormatter } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import SplitInputField from '@techsoftware/happay-widgets/SplitInputField';
import Spinner from '@techsoftware/happay-widgets/Spinner';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Popup from '@techsoftware/happay-widgets/Popup';

const BulkConfirmation = props => {
  const {
    generateOTP,
    handleActionClick,
    userInfo = {},
    type,
    onClose,
    bulkInvoiceDetail: { grossPayable = 0, totalSelected, currency } = {},
  } = props;
  const [state, setState] = useState({
    openOTP: false,
    otp: '',
    disableResend: false,
    infoPopup: false,
  });

  const { bulkInvoiceDetail = {} } = props;

  const { openOTP = false, otp, disableResend } = state;

  const handleConfirm = () => {
    if (!openOTP) {
      generateOTP();
      setState({
        ...state,
        openOTP: true,
      });
    } else if (openOTP) {
      handleActionClick(otp);
    }
  };

  const handleInput = (e, val) => {
    setState({
      ...state,
      otp: val,
    });
  };

  const handleResendOTP = () => {
    startResendTimer();
    generateOTP();
    setState({
      ...state,
      disableResend: true,
    });
  };

  const startResendTimer = () => {
    const display = document.querySelector('#timer-1');
    let count = 60;
    const timeInterval = setInterval(() => {
      if (count === 0) {
        display.textContent = '';
        setState({
          ...state,
          disableResend: false,
        });
        clearInterval(timeInterval);
      } else if (display) {
        display.textContent = count--;
      }
    }, 1000);
  };

  const returnOTPInput = () => {
    const {
      mobile_extension: mobileExtension = '',
      mobile_number: mobileNumber = '',
    } = userInfo;
    return (
      <div className="otp-dialog-container">
        <div className="body">
          A 6-digit OTP has been sent to your registered mobile number
          <span className="fw-500 d-flex">
            {mobileExtension} {mobileNumber}
          </span>
        </div>
        <SplitInputField
          id="otp"
          length={6}
          value={otp}
          handleChange={handleInput}
          floatingLabelText="Enter OTP"
          isNumberType
          customInputLabelStyle={{
            marginTop: '20px',
            textAlign: 'left',
          }}
          autoFocus
        />
        <Grid container justify="space-between" className="margin-t-10">
          <div
            onClick={disableResend ? () => {} : handleResendOTP}
            className={`font-12 fw-500 ${
              disableResend ? 'body light' : 'pointer primary-blue-color'
            } pos-relative flex-center`}
          >
            Resend OTP
            {disableResend && <span className="margin-l-6">in</span>}
            <div className="pos-relative flex-center">
              {disableResend && <Spinner className="margin-l-6" />}
              <div className="timer-counter align-center" id="timer-1"></div>
            </div>
          </div>
          <div className="body font-12">The OTP is valid for 5 mins only</div>
        </Grid>
      </div>
    );
  };

  const onMouseEnter = () => {
    setState({
      ...state,
      infoPopup: true,
    });
  };

  const onMouseLeave = () => {
    setState({
      ...state,
      infoPopup: false,
    });
  };

  const returnAmountDetails = (title, key, extraEle, containerClass = '') => (
    <Grid
      container
      item
      justify="space-between"
      className={`font-12 fw-500 body ${containerClass}`}
    >
      <Grid item container justify="flex-start" className="padding-8" xs={16}>
        {title}
      </Grid>
      <Grid item container justify="flex-end" xs={8} className="padding-8">
        {extraEle ? <span className="margin-r-6">{extraEle}</span> : null}{' '}
        {currencyFormatter(bulkInvoiceDetail[key], currency)}
      </Grid>
    </Grid>
  );

  const returnError = _ => {
    const { happay_processing_fee_percent = '1.4%' } = userInfo;

    return (
      <div>
        <div className="body">
          Total Invoices Selected:
          <span className="body dark fw-500 margin-l-6">{totalSelected}</span>
        </div>
        <div className="body margin-t-10">
          <div className="flex-vertical-center">
            Total Invoice Amount:
            <span className="body dark fw-500 margin-l-6">
              {currencyFormatter(grossPayable, currency)}
            </span>
            <Popup
              open={state.infoPopup}
              id="error-prompt"
              onClose={onMouseLeave}
              pointerPlacement={'top-center'}
              popupStyle={{ left: 16 }}
              variant="scroll"
              border
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              parentElement={
                <Icons
                  size="small"
                  className="primary-color"
                  type="info"
                  interactive
                />
              }
            >
              <div style={{ width: '240px' }} className="font-12 padding-16">
                The approved payments will be processed on their scheduled
                dates.
              </div>
            </Popup>
          </div>
        </div>
        <Grid
          container
          item
          justify="center"
          alignItems="center"
          className="margin-tb-20 border-b border-t border-l border-r border-radius-4 padding-20"
        >
          {returnAmountDetails('Gross Amount', 'grossBaseAmount')}
          {returnAmountDetails('GST', 'grossGST', '(+)')}
          {returnAmountDetails('TDS', 'grossTDS', '(-)')}
          {returnAmountDetails('Discount', 'grossDiscount', '(-)')}
          {returnAmountDetails(
            `Happay Processing Fee @ ${happay_processing_fee_percent} (incl. GST)`,
            'happayProcessingFee',
            '(+)',
            'primary-color fw-600 margin-b-6',
          )}
          {returnAmountDetails(
            'Total Amount Payable',
            'finalAmount',
            null,
            'dark font-14 border-t',
          )}
        </Grid>
        <div className="body font-12">
          *An OTP will be sent to your registered number for authentication.
        </div>
      </div>
    );
  };

  const title =
    type === 'Decline'
      ? 'Decline Invoices'
      : !openOTP
      ? `Invoices Summary`
      : 'Verify OTP';
  const buttonText = !openOTP ? 'Generate OTP' : 'Submit OTP';
  const body =
    type === 'Decline'
      ? 'Are you sure you want to decline the invoices?'
      : !openOTP
      ? returnError()
      : returnOTPInput();

  return (
    <DialogBox
      open
      id="error-prompt"
      onClose={onClose}
      title={title}
      titleStyle={{ fontWeight: 500 }}
      actionBorder
      crossIcon
      width="500px"
      height={type === 'Decline' && '200px'}
      dialogTitleContainerStyle={{ paddingBottom: '0px' }}
      actions={
        <div>
          {type === 'Decline' ? (
            <>
              <Button
                type="button"
                text="No"
                size="medium"
                variant="secondary"
                className="margin-r-24"
                onClick={onClose}
              />
              <Button
                type="button"
                text="Yes"
                size="medium"
                variant="primary"
                onClick={() => handleActionClick()}
              />
            </>
          ) : (
            <Button
              type="button"
              text={buttonText}
              size="medium"
              variant="primary"
              disabled={openOTP && otp.length < 6}
              onClick={handleConfirm}
            />
          )}
        </div>
      }
    >
      <div className="padding-lr-30 padding-b-30 padding-t-16">{body}</div>
    </DialogBox>
  );
};

export default BulkConfirmation;
